import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PublisherUserAuthenticationService } from '../_services/authentication.service';
import { Helpers } from '../../../helpers';

@Component({
    selector: 'app-publisher-user-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublisherUserLogoutComponent implements OnInit {
    constructor(
        private _router: Router,
        private _authService: PublisherUserAuthenticationService
    ) { }

    ngOnInit(): void {
        Helpers.setLoading(true);
        this._authService.logout();
        this._router.navigate(['/publisher/login']);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/logout/logout.component.ts